var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('kst-input',{attrs:{"load-on-focus":"","field":"Password","data":_vm.userData,"catalog":_vm.Catalog,"customValidations":_vm.passwordValidations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }